export class ImportFileLoadsColumn {

  public name: string;
  public type: string;
  public sample: any;

  static fromDto(data: any) {
    if (!data) {
      return null;
    }

    const column = new ImportFileLoadsColumn();

    column.name   = data.name;
    column.type   = data.type;
    column.sample = data.sample;

    return column;
  }
}

export enum ImportFileLoadsColumnType {
  STRING    = 'STRING',
  NUMBER    = 'NUMBER',
  LATITUDE  = 'LATITUDE',
  LONGITUDE = 'LONGITUDE',
  DATE      = 'DATE',
  ENUM      = 'ENUM'
}
